<!--
    文件描述：弹出框组件
    创建人：殷俊
    创建时间：2022-07-01
-->
<template>
    <div :class='{shade: true, shadow: isShade()}'>
        <div class='tipDialog' v-if='$parent.dialog.data.type==="tip"'>
            {{$parent.dialog.data.message}}
        </div>
        <div class='alertDialog' v-if='$parent.dialog.data.type==="alert"'>
            <div class='title'>提示</div>
            <div class='content' v-html='$parent.dialog.data.message'></div>
            <div class='button' @click='confirm()'>确定</div>
        </div>
        <div class='confirmDialog' v-if='$parent.dialog.data.type==="confirm"'>
            <div class='title'>提示</div>
            <div class='content' v-html='$parent.dialog.data.message'></div>
            <div class='button'>
                <button class='close' v-on:click="close()">{{$parent.dialog.data.cancelText}}</button>
                <button class='confirm' v-on:click="confirm()">{{$parent.dialog.data.confirmText}}</button>
            </div>
        </div>
        <div class='loadingDialog' v-if='$parent.dialog.data.type==="loading"'>
            <img class="loadingImg" src="../assets/images/common/loading.gif" alt="">
            <div>{{$parent.dialog.data.message}}</div>
        </div>
        <div class='imgDialog' :style="{'width': $parent.dialog.data.width, 'height': $parent.dialog.data.height }" v-if='$parent.dialog.data.type==="img"' @touchmove.prevent>
            <img class='close' src='../assets/images/common/close.png' @click="close()">
            <img class='img' :src='$parent.dialog.data.src' @click="close()">
        </div>

        <!-- 删除 -->
        <div class='deleteDialog' v-if='$parent.dialog.data.type==="delete"'>
            <div class='content' v-html='$parent.dialog.data.message'></div>
            <div class='button'>
                <button class='close' v-on:click="close()">{{$parent.dialog.data.cancelText}}</button>
                <button class='confirm' v-on:click="confirm()">{{$parent.dialog.data.confirmText}}</button>
            </div>
        </div>

        <!-- 编辑地址 -->
        <div class='editorAddrDialog' v-if='$parent.dialog.data.type==="editorAddr"'>
            <div class='title'>编辑地址</div>
            <img class='close' src='../assets/images/common/close.png' @click="close()">
            <div class='content'>
                <div class="name">
                    <span>*</span>
                    <span>收货人</span>
                    <input placeholder="请输入收货人姓名">
                    <p>收货人姓名长度需要在2-25个汉字或字符之间，不能包含特殊符号</p>
                </div>
                <div class="address">
                    <span>*</span>
                    <span>收货地址</span>
                    <el-cascader v-model="value" :options="options" @change="handleChange"></el-cascader>
                    <input placeholder="请输入具体地址">
                </div>
                <div class="phone">
                    <span>*</span>
                    <span>手机号码</span>
                    <input placeholder="请输入收货人手机号码">
                </div>
                <div class="setDefault">
                    <img src="@/assets/images/store/shopping/selected.png">
                    <span>设为默认地址</span>
                </div>
            </div>
            <button @click='confirm()'>保存</button>
        </div>

        <!-- 新增地址 -->
        <div class='addAddrDialog' v-if='$parent.dialog.data.type==="addAddr"'>
            <div class='title'>新增地址</div>
            <img class='close' src='../assets/images/common/close.png' @click="close()">
            <div class='content'>
                <div class="name">
                    <span>*</span>
                    <span>收货人</span>
                    <input placeholder="请输入收货人姓名">
                    <p>收货人姓名长度需要在2-25个汉字或字符之间，不能包含特殊符号</p>
                </div>
                <div class="address">
                    <span>*</span>
                    <span>收货地址</span>
                    <el-cascader v-model="value" :options="options" @change="handleChange"></el-cascader>
                    <input placeholder="请输入具体地址">
                </div>
                <div class="phone">
                    <span>*</span>
                    <span>手机号码</span>
                    <input placeholder="请输入收货人手机号码">
                </div>
                <div class="setDefault">
                    <img src="@/assets/images/store/shopping/selected.png">
                    <span>设为默认地址</span>
                </div>
            </div>
            <button @click='confirm()'>确定</button>
        </div>
    </div>
</template>

<script type="text/javascript">
import {rv_dialog} from '../utils/DialogUtils'

export default {
    data() {
        return {
            value: [],
            options: [{
                value: 'zhinan',
                label: '指南',
                children: [{
                    value: 'shejiyuanze',
                    label: '设计原则',
                    children: [{
                        value: 'yizhi',
                        label: '一致'
                    }, {
                        value: 'fankui',
                        label: '反馈'
                    }, {
                        value: 'xiaolv',
                        label: '效率'
                    }, {
                        value: 'kekong',
                        label: '可控'
                    }]
                }, {
                    value: 'daohang',
                    label: '导航',
                    children: [{
                        value: 'cexiangdaohang',
                        label: '侧向导航'
                    }, {
                        value: 'dingbudaohang',
                        label: '顶部导航'
                    }]
                }]
            }, {
                value: 'zujian',
                label: '组件',
                children: [{
                    value: 'basic',
                    label: 'Basic',
                    children: [{
                        value: 'layout',
                        label: 'Layout 布局'
                    }, {
                        value: 'color',
                        label: 'Color 色彩'
                    }, {
                        value: 'typography',
                        label: 'Typography 字体'
                    }, {
                        value: 'icon',
                        label: 'Icon 图标'
                    }, {
                        value: 'button',
                        label: 'Button 按钮'
                    }]
                }, {
                    value: 'form',
                    label: 'Form',
                    children: [{
                        value: 'radio',
                        label: 'Radio 单选框'
                    }, {
                        value: 'checkbox',
                        label: 'Checkbox 多选框'
                    }, {
                        value: 'input',
                        label: 'Input 输入框'
                    }, {
                        value: 'input-number',
                        label: 'InputNumber 计数器'
                    }, {
                        value: 'select',
                        label: 'Select 选择器'
                    }, {
                        value: 'cascader',
                        label: 'Cascader 级联选择器'
                    }, {
                        value: 'switch',
                        label: 'Switch 开关'
                    }, {
                        value: 'slider',
                        label: 'Slider 滑块'
                    }, {
                        value: 'time-picker',
                        label: 'TimePicker 时间选择器'
                    }, {
                        value: 'date-picker',
                        label: 'DatePicker 日期选择器'
                    }, {
                        value: 'datetime-picker',
                        label: 'DateTimePicker 日期时间选择器'
                    }, {
                        value: 'upload',
                        label: 'Upload 上传'
                    }, {
                        value: 'rate',
                        label: 'Rate 评分'
                    }, {
                        value: 'form',
                        label: 'Form 表单'
                    }]
                }, {
                    value: 'data',
                    label: 'Data',
                    children: [{
                        value: 'table',
                        label: 'Table 表格'
                    }, {
                        value: 'tag',
                        label: 'Tag 标签'
                    }, {
                        value: 'progress',
                        label: 'Progress 进度条'
                    }, {
                        value: 'tree',
                        label: 'Tree 树形控件'
                    }, {
                        value: 'pagination',
                        label: 'Pagination 分页'
                    }, {
                        value: 'badge',
                        label: 'Badge 标记'
                    }]
                }, {
                    value: 'notice',
                    label: 'Notice',
                    children: [{
                        value: 'alert',
                        label: 'Alert 警告'
                    }, {
                        value: 'loading',
                        label: 'Loading 加载'
                    }, {
                        value: 'message',
                        label: 'Message 消息提示'
                    }, {
                        value: 'message-box',
                        label: 'MessageBox 弹框'
                    }, {
                        value: 'notification',
                        label: 'Notification 通知'
                    }]
                }, {
                    value: 'navigation',
                    label: 'Navigation',
                    children: [{
                        value: 'menu',
                        label: 'NavMenu 导航菜单'
                    }, {
                        value: 'tabs',
                        label: 'Tabs 标签页'
                    }, {
                        value: 'breadcrumb',
                        label: 'Breadcrumb 面包屑'
                    }, {
                        value: 'dropdown',
                        label: 'Dropdown 下拉菜单'
                    }, {
                        value: 'steps',
                        label: 'Steps 步骤条'
                    }]
                }, {
                    value: 'others',
                    label: 'Others',
                    children: [{
                        value: 'dialog',
                        label: 'Dialog 对话框'
                    }, {
                        value: 'tooltip',
                        label: 'Tooltip 文字提示'
                    }, {
                        value: 'popover',
                        label: 'Popover 弹出框'
                    }, {
                        value: 'card',
                        label: 'Card 卡片'
                    }, {
                        value: 'carousel',
                        label: 'Carousel 走马灯'
                    }, {
                        value: 'collapse',
                        label: 'Collapse 折叠面板'
                    }]
                }]
            }, {
                value: 'ziyuan',
                label: '资源',
                children: [{
                    value: 'axure',
                    label: 'Axure Components'
                }, {
                    value: 'sketch',
                    label: 'Sketch Templates'
                }, {
                    value: 'jiaohu',
                    label: '组件交互文档'
                }]
            }]
        }
    },

    methods: {
        // 开启页面滚动
        move() {
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', rv_dialog.preventDefault, { passive: true });
        },

        /**
            关闭弹出框
            @param
            @return
        */
        close() {
            this.$parent.dialog.data.show = false
            if (typeof (this.$parent.dialog.data.cancelCallBack) === 'function') {
                this.$parent.dialog.data.cancelCallBack()
            }

            this.move();
        },
        /**
            确定
            @param
            @return
        */
        confirm() {
            this.$parent.dialog.data.show = false
            if (typeof (this.$parent.dialog.data.confirmCallBack) === 'function') {
                this.$parent.dialog.data.confirmCallBack()
            }
        },

        /**
            是否有遮罩
            @param
            @return
        */
        isShade() {
            const type = this.$parent.dialog.data.type
            if (type === 'alert' || type === 'confirm' || type === 'img') {
                return true
            }
            return false
        },

        /**
         * 级联框值改变事件
         * @param
         * @return
         */
        handleChange(value) {
            console.log(value);
        }
    }
}
</script>

<style lang="less" scoped>
/** Dialog **/
.shade{
    position: fixed;
    z-index: 2000;
    top: 0; right: 0; bottom: 0; left: 0;
    display: flex; align-items: center; justify-content: center;
    >.tipDialog {
        margin: auto; padding: 0.10rem 0.35rem;
        text-align: center;
        border-radius: 0.20rem;
        color: white; background-color: rgba(0, 0, 0, 0.5);
    }
    >.alertDialog {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        margin: auto;
        width: 80%; height: 160px;
        border-radius: 0.05rem;
        background-color: white;
        font-size: 16px;
        >.title {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 40px;
            text-align: center; line-height: 40px;
            border-bottom: 1px solid #eee;
            border-top-left-radius: 5px; border-top-right-radius: 5px;
        }
        >.content {
            position: absolute;
            top: 40px; left: 0;
            width: 100%; height: 100px;
            text-align: center; line-height: 100px;
            color: #000;
        }
        >.button {
            position: absolute;
            top: 140px;
            bottom: 0; left: 0;
            width: 100%; height: 50px;
            text-align: center; line-height: 50px;
            border-top: 1px solid #26c2c4;
            background-color: #26c2c4;
        }
    }
    >.confirmDialog {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        margin: auto;
        width: 90%; height: 2.00rem;
        border-radius: 0.05rem;
        background-color: white;
        >.title {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 0.50rem;
            text-align: center; line-height: 0.50rem;
            border-bottom: 0.01rem solid #eee;
            border-top-left-radius: 0.05rem; border-top-right-radius: 0.05rem;
        }
        >.content {
            position: absolute;
            top: 0.50rem; left: 0;
            width: 100%; height: 1.00rem;
            padding: 0.25rem 0.15rem;
            text-align: center; line-height: 0.26rem;
            color: #000;
        }
        >.button {
            position: absolute;
            bottom: 0; left: 0;
            width: 100%; height: 0.50rem;
            text-align: center; line-height: 0.50rem;
            border-bottom-left-radius: 0.05rem; border-bottom-right-radius: 0.05rem;
            >.close {
                float: left;
                width: 50%; height: 0.50rem;
                border-top: 0.01rem solid #eee;
                border-bottom-left-radius: 0.05rem;
                background-color: white;
            }
            >.confirm {
                float: right;
                width: 50%; height: 0.50rem;
                border-top: 0.01rem solid #26c2c4;
                border-bottom-right-radius: 0.05rem;
                color: white; background-color: #26c2c4;
            }
        }
    }
    >.imgDialog {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        margin: auto;
        width: 4.50rem; height: 4.50rem;
        border-radius: 0.05rem;
        background-color: white;
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: -0.24rem -0.24rem auto auto;
            width: 0.56rem;
            height: 0.56rem;
            cursor: pointer;
        }
        >.img {
            width: 100%; height: 100%;
        }
    }
    >.deleteDialog {
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        margin: auto;
        width: 2.8rem; height: 1.5rem;
        border: 0.04rem solid rgba(26,57,106,0.2);
        background-color: white;
        >.title {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 0.50rem;
            text-align: center; line-height: 0.50rem;
            border-bottom: 0.01rem solid #eee;
            border-top-left-radius: 0.05rem; border-top-right-radius: 0.05rem;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            text-align: center;
            font-size: 0.14rem;
            color: #333333;
        }
        >.button {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0.50rem;
            text-align: center;

            >.confirm {
                width: 1rem;
                height: 0.3rem;
                background: #1A396A;
                border-radius: 0.02rem;
                font-size: 0.14rem;
                color: #fff;
            }

            >.close {
                position: absolute;
                right: 0.47rem;
                bottom: 0.21rem;
                font-size: 0.12rem;
                color: #999999;
                background-color: #fff;
            }
        }
    }
    >.editorAddrDialog, .addAddrDialog {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 6rem;
        height: 5rem;
        background: #FFFFFF;
        border: 0.04rem solid rgba(26,57,106,0.2);
        border-radius: 0.02rem;
        >.title {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 0.18rem 0 0.34rem;
            width: 100%;
            height: 0.44rem;
            background: #1A396A;
            border-radius: 0.02rem 0.02rem 0 0;
            line-height: 0.44rem;
            text-align: left;
            color: #FFFFFF;
            font-size: 0.18rem;
        }
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: 0.15rem 0.15rem auto auto;
            width: 0.14rem;
            height: 0.14rem;
            cursor: pointer;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            font-size: 0.14rem;
            color: #333333;
            >.name {
                margin: 0.27rem 0 0 0.35rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
                >p {
                    margin: 0.08rem 0 0 0.64rem;
                    font-size: 0.12rem;
                    color: #F75959;
                }
            }
            >.address {
                margin: 0.17rem 0 0 0.21rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                /deep/.el-input__inner {
                    margin-left: 0.08rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                    border-radius: 0;
                }
                >input {
                    margin: 0.12rem 0 0 0.78rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
            >.phone {
                margin: 0.2rem 0 0 0.21rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
            >.setDefault {
                position: relative;
                top: 0.15rem;
                height: 0.2rem;
                >img {
                    position: absolute;
                    top: 0.03rem;
                    left: 1.05rem;
                    width: 0.14rem;
                    height: 0.14rem;
                }
                >span {
                    position: absolute;
                    left: 1.28rem;
                    font-size: 0.14rem;
                    color: #666666;
                }
            }
        }
        >button {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0.4rem;
            margin: 0 auto;
            width: 1.2rem;
            height: 0.48rem;
            background: #1A396A;
            border-radius: 0.04rem;
            color: #FFFFFF;
            line-height: 0.48rem;
        }
    }

    >.invoiceTypeDialog {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 6rem;
        height: 3.9rem;
        background: #FFFFFF;
        border: 0.04rem solid rgba(26,57,106,0.2);
        border-radius: 0.02rem;
        >.title {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 0.18rem 0 0.34rem;
            width: 100%;
            height: 0.44rem;
            background: #1A396A;
            border-radius: 0.02rem 0.02rem 0 0;
            line-height: 0.44rem;
            text-align: left;
            color: #FFFFFF;
            font-size: 0.18rem;
        }
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: 0.15rem 0.15rem auto auto;
            width: 0.14rem;
            height: 0.14rem;
            cursor: pointer;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            font-size: 0.14rem;
            color: #333333;
            text-align: center;
            >div {
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;
                width: 4.62rem;
                height: 0.5rem;
                border: 0.01rem solid #999999;
                color: #999;
                line-height: 0.5rem;
                cursor: pointer;
            }
            >.general {
                top: 0.32rem;
            }
            >.specialForPerson {
                top: 1.02rem;
            }
            >.specialForCompany {
                top: 1.72rem;
            }
            >.active {
                border: 0.01rem solid #1A396A;
                color: #1A396A;
            }
        }
        >button {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0.4rem;
            margin: 0 auto;
            width: 1.2rem;
            height: 0.48rem;
            background: #1A396A;
            border-radius: 0.04rem;
            color: #FFFFFF;
            line-height: 0.48rem;
        }
    }
    >.generalInvoiceDialog {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 6rem;
        height: 5rem;
        background: #FFFFFF;
        border: 0.04rem solid rgba(26,57,106,0.2);
        border-radius: 0.02rem;
        >.title {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 0.18rem 0 0.34rem;
            width: 100%;
            height: 0.44rem;
            background: #1A396A;
            border-radius: 0.02rem 0.02rem 0 0;
            line-height: 0.44rem;
            text-align: left;
            color: #FFFFFF;
            font-size: 18px;
        }
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: 0.15rem 0.15rem auto auto;
            width: 0.14rem;
            height: 0.14rem;
            cursor: pointer;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            font-size: 0.14rem;
            color: #333333;
            >.name {
                margin: 38px 0 0 18px;
                > span:nth-child(1) {
                    font-size: 14px;
                    color: #FF0000;
                }
                > span:nth-child(2) {
                    color: #333333;
                }
                > input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
            >.invoiceContent {
                margin: 27px 0 0 36px;
                > span:nth-child(2) {
                    color: #333333;
                }
                > div {
                    display: inline-block;
                    margin-right: 18px;
                    width: 222px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666;
                    line-height: 50px;
                    text-align: center;
                    cursor: pointer;
                }
                >.active {
                    border: 1px solid #1A396A;
                    color: #1A396A;
                }
                > p {
                    margin: 8px 0 0 64px;
                    font-size: 12px;
                    color: #999;
                }
            }
            >.phone {
                margin: 20px 0 0 18px;
                >span:nth-child(1) {
                    font-size: 14px;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
        }
        >button {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 40px;
            margin: 0 auto;
            width: 120px;
            height: 48px;
            background: #1A396A;
            border-radius: 4px;
            color: #FFFFFF;
            line-height: 48px;
        }
    }
    >.specialForPersonDialog {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 600px;
        height: 680px;
        background: #FFFFFF;
        border: 4px solid rgba(26,57,106,0.2);
        border-radius: 2px;
        >.title {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 18px 0 34px;
            width: 100%;
            height: 44px;
            background: #1A396A;
            border-radius: 2px 2px 0px 0px;
            line-height: 0.44rem;
            text-align: left;
            color: #FFFFFF;
            font-size: 18px;
        }
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: 0.15rem 0.15rem auto auto;
            width: 0.14rem;
            height: 0.14rem;
            cursor: pointer;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            font-size: 0.14rem;
            color: #333333;
            >.invoiceWay {
                margin: 32px 0 0 28px;
                >span {
                    color: #333;
                }
                >div {
                    display: inline-block;
                    margin-left: 8px;
                    width: 462px;
                    height: 50px;
                    background: #E5E5E5;
                    border: 1px solid #D1D1D1;
                    color: #333;
                    line-height: 50px;
                    text-align: center;
                }
            }
            >.invoiceContent {
                margin: 20px 0 0 28px;
                >span {
                    color: #333;
                }
                >div {
                    display: inline-block;
                    margin-left: 8px;
                    width: 462px;
                    height: 50px;
                    background: #E5E5E5;
                    border: 1px solid #D1D1D1;
                    color: #333;
                    line-height: 50px;
                    text-align: center;
                }
            }
            >.name {
                margin: 20px 0 0 5px;
                >span:nth-child(1) {
                    font-size: 14px;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
            >.cellPhone {
                margin: 20px 0 0 32px;
                >span:nth-child(1) {
                    font-size: 14px;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
            >.telPhone {
                margin: 20px 0 0 28px;
                >span {
                    color: #333333;
                }
                >input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
            >.address {
                margin: 20px 0 0 18px;
                >span:nth-child(1) {
                    font-size: 14px;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 8px;
                    padding: 0 15px;
                    width: 462px;
                    height: 50px;
                    border: 1px solid #E5E5E5;
                    color: #666666;
                }
            }
        }
        >.buttonArea {
            >button:nth-child(1) {
                position: absolute;
                left: 154px;
                bottom: 46px;
                width: 120px;
                height: 48px;
                background-color: #fff;
                border: 1px solid #999999;
                border-radius: 4px;
                font-size: 14px;
                line-height: 48px;
                color: #666666;
            }
            >button:nth-child(2) {
                position: absolute;
                right: 154px;
                bottom: 46px;
                width: 120px;
                height: 48px;
                background: #1A396A;
                border-radius: 4px;
                color: #FFFFFF;
                line-height: 48px;
            }
        }
    }
    >.specialForCompanyDialog {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 600px;
        height: 680px;
        background: #FFFFFF;
        border: 4px solid rgba(26,57,106,0.2);
        border-radius: 2px;
        >.title {
            position: absolute;
            top: 0;
            left: 0;
            padding: 0 18px 0 34px;
            width: 100%;
            height: 44px;
            background: #1A396A;
            border-radius: 2px 2px 0px 0px;
            line-height: 0.44rem;
            text-align: left;
            color: #FFFFFF;
            font-size: 18px;
        }
        >.close {
            position: absolute;
            top: 0;
            right: 0;
            margin: 0.15rem 0.15rem auto auto;
            width: 0.14rem;
            height: 0.14rem;
            cursor: pointer;
        }
        >.content {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0.4rem auto 0 auto;
            font-size: 0.14rem;
            color: #333333;
            >.invoiceWay {
                margin: 0.32rem 0 0 0.28rem;
                >span {
                    color: #333;
                }
                >div {
                    display: inline-block;
                    margin-left: 0.08rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    background: #E5E5E5;
                    border: 0.01rem solid #D1D1D1;
                    color: #333;
                    line-height: 0.5rem;
                    text-align: center;
                }
            }
            >.invoiceContent {
                margin: 0.2rem 0 0 0.28rem;
                >span {
                    color: #333;
                }
                >div {
                    display: inline-block;
                    margin-left: 0.08rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    background: #E5E5E5;
                    border: 0.01rem solid #D1D1D1;
                    color: #333;
                    line-height: 0.5rem;
                    text-align: center;
                }
            }
            >.name {
                margin: 0.2rem 0 0 0.17rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
            >.sbh {
                margin: 0.2rem 0 0 0.17rem;
                >span {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >div {
                    display: inline-block;
                    position: relative;
                    top: 0.12rem;
                    width: 0.55rem;
                    height: 0.5rem;
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
            >.address {
                margin: 0.2rem 0 0 0.17rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
                >.error {
                    margin: 0.02rem 0 0 0.8rem;
                    >img {
                        position: relative;
                        top: 0.02rem;
                        width: 0.14rem;
                        height: 0.14rem;
                    }
                    >p {
                        display: inline-block;
                        font-size: 0.12rem;
                        color: #FF3838;
                    }
                }

            }
            >.bank {
                margin: 0.1rem 0 0 0.17rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
            >.bankAccount {
                margin: 0.2rem 0 0 0.17rem;
                >span:nth-child(1) {
                    font-size: 0.14rem;
                    color: #FF0000;
                }
                >span:nth-child(2) {
                    color: #333333;
                }
                >input {
                    margin-left: 0.08rem;
                    padding: 0 0.15rem;
                    width: 4.62rem;
                    height: 0.5rem;
                    border: 0.01rem solid #E5E5E5;
                    color: #666666;
                }
            }
        }
        >.buttonArea {
            >button:nth-child(1) {
                position: absolute;
                left: 1.54rem;
                bottom: 0.4rem;
                width: 1.2rem;
                height: 0.48rem;
                background-color: #fff;
                border: 0.01rem solid #999999;
                border-radius: 0.04rem;
                font-size: 0.14rem;
                line-height: 0.48rem;
                color: #666666;
            }
            >button:nth-child(2) {
                position: absolute;
                right: 1.54rem;
                bottom: 0.4rem;
                width: 1.2rem;
                height: 0.48rem;
                background: #1A396A;
                border-radius: 0.04rem;
                color: #FFFFFF;
                line-height: 0.48rem;
            }
        }
    }
}
.shade.shadow {
    background-color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue